import type {ComponentProps} from 'react';

/** Completed creatives use their own intrinsic ratio, never the current composer setting. */
export function GeneratedImagePreview({style,...props}:ComponentProps<'img'>){
 return <img {...props} style={{display:'block',width:'auto',height:'auto',maxWidth:'min(160px, 100%)',maxHeight:160,objectFit:'contain',flexShrink:0,...style}}/>;
}
